export const configuracaoTemaMixin = {
    computed: {
        tema() {
            const {clienteFormulario} = this.$store.state;            
            if(clienteFormulario){
                const { configuracaoTemaCliente } = clienteFormulario;
                return configuracaoTemaCliente;
            }
            
            return null;
        },
        corPrimariaTopo(){
            return (this.tema && this.tema.corPrimariaTopo ) || "#5a45de" // Cor Padrão;
        },
        corPrimariaTopoLogin(){
            return (this.tema && this.tema.corPrimariaTopoLogin ) || "" // Cor Padrão;
        },
        urlLogo(){
            return this.tema && this.tema.urlLogo || null;
        },
        urlBannerFormulario(){
            return this.tema && this.tema.urlBannerFormulario || null
        },
        corTextoPrimaria(){
            return this.tema && this.tema.corTextoPrimaria || '#17a2b8';
        },
        isDebug(){
            return this.$store.state.isDebug;
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/ConfiguracaoTemaMixin.js